// extracted by mini-css-extract-plugin
export default {"box":"Rates_box__um4p0","label":"Rates_label__UcRMT"};